import {Component, Input, OnInit} from '@angular/core';
import {BlacklistRemarkModel} from '../../../../shared/dto/blacklist-remark.model';

@Component({
  selector: 'app-revered-blacklist-remark-details',
  templateUrl: './revered-blacklist-remark-details.component.html',
  styleUrls: ['./revered-blacklist-remark-details.component.scss']
})
export class ReveredBlacklistRemarkDetailsComponent implements OnInit {
  @Input() data: BlacklistRemarkModel[];
  @Input() dataEXM: BlacklistRemarkModel[];
  @Input() dataDG: BlacklistRemarkModel[];
  @Input() index: number;
  @Input() page: number=1;
  @Input() itemsPerPage: number=5;
  constructor() { }

  ngOnInit() {
  }

}
